if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const offCodeNode = $(this).parents('product-info').find('lepro-off-code')

        const checkoutButton = $(this).closest('product-info').find('lepro-fixed-add-cart .checkout-btn')
        const detailDialog = this.closest('collection-product-detail')
        const collectionAction = detailDialog ? evt.submitter?.dataset.collectionDetailAction : null
        const isCheckout = collectionAction ? collectionAction === 'checkout' : Boolean(checkoutButton.attr('data-link'))
        const checkoutDirect = isCheckout && detailDialog?.dataset.checkoutDirect === 'true'
        const checkoutCoupon = window.isB2BCustomer ? '' : (offCodeNode[0]?.code || '').trim()
        checkoutButton.removeAttr('data-link')
        let discountFailed = false

        return fetch(`${routes.cart_add_url}`, config)
          .then(async (response) => {
            const cartData = await response.json()
            if (checkoutDirect && !response.ok) throw new Error(cartData.description || cartData.message || 'Unable to add item to cart')
            if (!response.ok || cartData.status) return cartData
            if (checkoutDirect) return cartData
            try {
              await window.ShopifyConstant.applyCartDiscountCodes([offCodeNode[0]?.code])
            } catch (error) {
              discountFailed = true
              window.ShopifyConstant.reportCartDiscountError(error)
            }

            return cartData
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (checkoutDirect) {
              window.location.href = checkoutCoupon ? `/discount/${encodeURIComponent(checkoutCoupon)}?redirect=%2Fcheckout` : '/checkout'
              return
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (isCheckout && !discountFailed) {
              window.location.href='/checkout'
              return
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal, collection-product-detail');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            if (checkoutDirect) this.handleErrorMessage(e.message);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);

            $('.lepro-fixed-add-cart .add-cart-btn').attr('disabled', false)
            $('.lepro-fixed-add-cart .add-cart-btn').removeClass('loading')
            $('.lepro-fixed-add-cart .add-cart-btn .loading__spinner').addClass('hidden')

            // 加购完成后重置折扣 toggle：取消勾选 + 触发 change 让两处价格都恢复原价
            const offToggle = offCodeNode[0]?.querySelector?.('.discount-toggle')
            if (offToggle?.checked) {
              offToggle.checked = false
              offToggle.dispatchEvent(new Event('change', { bubbles: true }))
            }

            if (isCheckout) {
              $('.lepro-fixed-add-cart .checkout-btn').attr('disabled', false)
              $('.lepro-fixed-add-cart .checkout-btn').removeClass('loading')
              $('.lepro-fixed-add-cart .checkout-btn .loading__spinner').addClass('hidden')
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
